import store from '../../store';

import EditCompanyGoalsView from '../../views/Companies/Company/EditCompanyGoalsView.vue';
import EditCompanyGoalsBadgesView from '../../views/Companies/Company/EditCompanyGoalsBadgesView.vue';
import EditCompanyTasksBadgesView from '../../views/Companies/Company/EditCompanyTasksBadgesView.vue';
import EditCompanyModulesView from '../../views/Companies/Company/EditCompanyModulesView.vue';
import EditCompanyModulesBadgesView from '../../views/Companies/Company/EditCompanyModulesBadgesView.vue';
import CompanyProgramUsers from '../../views/Companies/Company/CompanyProgramUsers.vue';
import CustomizeCompanyView from '../../views/Companies/Company/CustomizeCompanyView.vue';
import CustomizeCompanyProgramView from '../../views/Companies/Company/CustomizeCompanyProgramView.vue';
import CustomizeCompanyProgramJourneyView from '../../views/Companies/Company/CustomizeCompanyProgramJourneyView.vue';
import CompanyProgramSurveysView from '../../views/Companies/Company/CompanyProgramSurveysView.vue';
import CompanyProgramSurveyResponses from '../../views/Companies/Company/CompanyProgramSurveyResponses.vue';
import CreateCompanyProgram from '../../views/Companies/Company/CreateCompanyProgram.vue';

import MentorshipGroupsView from '../../views/Companies/Company/MentorshipGroups.vue';
import MentorshipGroupView from '../../views/Companies/Company/MentorshipGroup/MentorshipGroup.vue';

import VideoMeetingsView from '../../views/Companies/Company/VideoMeetings.vue';
import VideoMeetingView from '../../views/Companies/Company/VideoMeeting.vue';

import ExpertsView from '../../views/Companies/Company/Experts.vue';
import ExpertView from '../../views/Companies/Company/Expert.vue';

const companiesView = import(/* webpackChunkName: "sadminviews" */ '../../views/Companies/CompaniesView.vue');
const companyView = import(/* webpackChunkName: "staffviews" */ '../../views/Companies/Company/CompanyView.vue');

const metaSuperAdmin = {
  requiresLogin: true,
  requiresUserType: store.state.User.accountTypes.superAdmin,
};

const metaStaff = {
  requiresLogin: true,
  requiresUserType: store.state.User.accountTypes.staff,
};

export default {
  superAdmin: [
    {
      path: 'companies',
      name: 'companies',
      component() {
        return companiesView;
      },
      meta: metaSuperAdmin,
    },
    {
      path: 'companies/create',
      name: 'createCompany',
      component() {
        return companiesView;
      },
      meta: metaSuperAdmin,
      props: {
        create: true,
      },
    },
    {
      path: 'companies/edit/:id',
      name: 'viewCompany',
      component() {
        return companyView;
      },
      meta: metaSuperAdmin,
      props: true,
    },
    {
      path: 'companies/edit/:id/customize-experience',
      name: 'customizeCompany',
      component: CustomizeCompanyView,
      meta: metaSuperAdmin,
      props: true,
    },
    {
      path: 'companies/edit/:id/new-program',
      name: 'createCompanyProgram',
      component: CreateCompanyProgram,
      meta: metaSuperAdmin,
      props: true,
    },
    {
      path: 'companies/edit/:id/:programId/users',
      name: 'editCompanyProgramUsers',
      component: CompanyProgramUsers,
      meta: metaSuperAdmin,
      props: true,
    },
    {
      path: 'companies/edit/:id/:programId/modules',
      name: 'editCompanyProgramModules',
      component: EditCompanyModulesView,
      meta: metaSuperAdmin,
      props: true,
    },
    {
      path: 'companies/edit/:id/:programId/goals',
      name: 'editCompanyProgramGoals',
      component: EditCompanyGoalsView,
      meta: metaSuperAdmin,
      props: true,
    },
    {
      path: 'companies/edit/:id/:programId/goals-badges',
      name: 'editCompanyProgramGoalsBadges',
      component: EditCompanyGoalsBadgesView,
      meta: metaSuperAdmin,
      props: true,
    },
    {
      path: 'companies/edit/:id/:programId/tasks-badges',
      name: 'editCompanyProgramTasksBadges',
      component: EditCompanyTasksBadgesView,
      meta: metaSuperAdmin,
      props: true,
    },
    {
      path: 'companies/edit/:id/:programId/modules-badges',
      name: 'editCompanyProgramModulesBadges',
      component: EditCompanyModulesBadgesView,
      meta: metaSuperAdmin,
      props: true,
    },
    {
      path: 'companies/edit/:id/:programId/customize',
      name: 'customizeCompanyProgram',
      component: CustomizeCompanyProgramView,
      meta: metaSuperAdmin,
      props: true,
    },
    {
      path: 'companies/edit/:id/:programId/customize/journey/:journeyId',
      name: 'customizeCompanyProgramJourney',
      component: CustomizeCompanyProgramJourneyView,
      meta: metaSuperAdmin,
      props: true,
    },
    {
      path: 'companies/edit/:id/:programId/surveys',
      name: 'companyProgramSurveys',
      component: CompanyProgramSurveysView,
      meta: metaSuperAdmin,
      props: true,
    },
    {
      path: 'companies/edit/:id/:programId/surveys/:questionTypeId/responses',
      name: 'companyProgramSurveyResponses',
      component: CompanyProgramSurveyResponses,
      meta: metaSuperAdmin,
      props: true,
    },
    {
      path: 'companies/edit/:id/:programId/video-meetings',
      name: 'videoMeetings',
      component: VideoMeetingsView,
      meta: metaSuperAdmin,
      props: true,
    }, {
      path: 'companies/edit/:id/:programId/video-meeting/:linkid',
      name: 'videoMeeting',
      component: VideoMeetingView,
      meta: metaSuperAdmin,
      props: true,
    },
    {
      path: 'companies/edit/:id/:programId/mentorship-groups',
      name: 'companyProgramMentorshipGroups',
      component: MentorshipGroupsView,
      meta: metaSuperAdmin,
      props: true,
    },
    {
      path: 'companies/edit/:id/:programId/mentorship-groups/:groupId',
      name: 'companyMentorshipGroup',
      component: MentorshipGroupView,
      meta: metaSuperAdmin,
      props: true,
      children: [
        {
          path: 'chat',
          name: 'companyMentorshipGroupChat',
          component() {
            return import(/* webpackChunkName: "mentorshipgroup" */ '../../views/Companies/Company/MentorshipGroup/MentorshipGroupChat.vue');
          },
          meta: metaStaff,
          props: true,
        },
        {
          path: 'tasks',
          name: 'companyMentorshipGroupTasks',
          component() {
            return import(/* webpackChunkName: "mentorshipgroup" */ '../../views/Companies/Company/MentorshipGroup/MentorshipGroupTasks.vue');
          },
          meta: metaStaff,
          props: true,
        },
        {
          path: 'tasks/:taskId/review',
          name: 'reviewGroupTask',
          component() {
            return import(/* webpackChunkName: "mentorshipgroup" */ '../../views/Companies/Company/MentorshipGroup/MentorshipGroupReviewTask.vue');
          },
          meta: metaStaff,
          props: true,
        },
        {
          path: 'tasks/:taskId/revert',
          name: 'revertGroupTask',
          component() {
            return import(/* webpackChunkName: "mentorshipgroup" */ '../../views/Companies/Company/MentorshipGroup/MentorshipGroupRevertTask.vue');
          },
          meta: metaStaff,
          props: true,
        },
        {
          path: 'settings',
          name: 'companyMentorshipGroupSettings',
          component() {
            return import(/* webpackChunkName: "mentorshipgroup" */ '../../views/Companies/Company/MentorshipGroup/MentorshipGroupSettings.vue');
          },
          meta: metaStaff,
          props: true,
        },
      ],
    },
    {
      path: 'companies/edit/:id/:programId/experts',
      name: 'experts',
      component: ExpertsView,
      meta: metaSuperAdmin,
      props: true,
    },
    {
      path: 'companies/edit/:id/:programId/experts/:expertId',
      name: 'expert',
      component: ExpertView,
      meta: metaSuperAdmin,
      props: true,
    },
  ],
  staff: [
    {
      path: 'my-license',
      name: 'myLicense',
      component() {
        return companyView;
      },
      meta: metaStaff,
    },
    {
      path: 'my-license/mentorship/users',
      name: 'editCompanyProgramUsers',
      component: CompanyProgramUsers,
      meta: metaStaff,
      props: true,
    },
    {
      path: 'my-license/mentorship/modules',
      name: 'editCompanyProgramModules',
      component: EditCompanyModulesView,
      meta: metaStaff,
      props: true,
    },
    {
      path: 'my-license/mentorship/goals',
      name: 'editCompanyProgramGoals',
      component: EditCompanyGoalsView,
      meta: metaStaff,
      props: true,
    },
    {
      path: 'my-license/mentorship/goals-badges',
      name: 'editCompanyProgramGoalsBadges',
      component: EditCompanyGoalsBadgesView,
      meta: metaStaff,
      props: true,
    },
    {
      path: 'my-license/mentorship/tasks-badges',
      name: 'editCompanyProgramTasksBadges',
      component: EditCompanyTasksBadgesView,
      meta: metaStaff,
      props: true,
    },
    {
      path: 'my-license/mentorship/customize-experience',
      name: 'customizeCompany',
      component: CustomizeCompanyView,
      meta: metaStaff,
      props: true,
    },
    {
      path: 'my-license/mentorship/customize-program-experience',
      name: 'customizeCompanyProgram',
      component: CustomizeCompanyProgramView,
      meta: metaStaff,
      props: true,
    },
    {
      path: 'my-license/mentorship/customize-program-experience/journey/:journeyId',
      name: 'customizeCompanyProgramJourney',
      component: CustomizeCompanyProgramJourneyView,
      meta: metaStaff,
      props: true,
    },
    {
      path: 'my-license/mentorship/surveys',
      name: 'companyProgramSurveys',
      component: CompanyProgramSurveysView,
      meta: metaStaff,
      props: true,
    },
    {
      path: 'my-license/mentorship/surveys/:questionTypeId/responses',
      name: 'companyProgramSurveyResponses',
      component: CompanyProgramSurveyResponses,
      meta: metaStaff,
      props: true,
    },
    {
      path: 'my-license/mentorship/video-meetings',
      name: 'videoMeetings',
      component: VideoMeetingsView,
      meta: metaStaff,
      props: true,
    },
    {
      path: 'my-license/mentorship/video-meeting/:linkid',
      name: 'videoMeeting',
      component: VideoMeetingView,
      meta: metaStaff,
      props: true,
    },
    {
      path: 'my-license/mentorship/mentorship-groups',
      name: 'companyProgramMentorshipGroups',
      component: MentorshipGroupsView,
      meta: metaStaff,
      props: true,
    },
    {
      path: 'my-license/mentorship/mentorship-groups/:groupId',
      name: 'companyProgramMentorshipGroup',
      component: MentorshipGroupView,
      meta: metaStaff,
      props: true,
      children: [
        {
          path: 'chat',
          name: 'companyMentorshipGroupChat',
          component() {
            return import(/* webpackChunkName: "mentorshipgroup" */ '../../views/Companies/Company/MentorshipGroup/MentorshipGroupChat.vue');
          },
          meta: metaStaff,
          props: true,
        },
        {
          path: 'tasks',
          name: 'companyMentorshipGroupTasks',
          component() {
            return import(/* webpackChunkName: "mentorshipgroup" */ '../../views/Companies/Company/MentorshipGroup/MentorshipGroupTasks.vue');
          },
          meta: metaStaff,
          props: true,
        },
        {
          path: 'tasks/:taskId/review',
          name: 'reviewGroupTask',
          component() {
            return import(/* webpackChunkName: "mentorshipgroup" */ '../../views/Companies/Company/MentorshipGroup/MentorshipGroupReviewTask.vue');
          },
          meta: metaStaff,
          props: true,
        },
        {
          path: 'tasks/:taskId/revert',
          name: 'revertGroupTask',
          component() {
            return import(/* webpackChunkName: "mentorshipgroup" */ '../../views/Companies/Company/MentorshipGroup/MentorshipGroupRevertTask.vue');
          },
          meta: metaStaff,
          props: true,
        },
        {
          path: 'settings',
          name: 'companyMentorshipGroupSettings',
          component() {
            return import(/* webpackChunkName: "mentorshipgroup" */ '../../views/Companies/Company/MentorshipGroup/MentorshipGroupSettings.vue');
          },
          meta: metaStaff,
          props: true,
        },
      ],
    },
    {
      path: 'my-license/mentorship/experts',
      name: 'experts',
      component: ExpertsView,
      meta: metaStaff,
      props: true,
    },
    {
      path: 'my-license/mentorship/experts/:expertId',
      name: 'expert',
      component: ExpertView,
      meta: metaStaff,
      props: true,
    },
  ],
};
